export default __webpack_public_path__ + "static/media/chalkboard.29d76b61.png";